import { useRef, useState, useEffect } from 'react'
import {connect} from 'formik'
import {scrollToRef, toSentence} from 'shared'

export const GeneralError = connect(({formik}) => {
  const [message, setMessage] = useState(null)
  const ref = useRef(null)

  useEffect(() => {
    if (!formik.isValidating && !formik.isSubmitting) {
      setMessage(formik.isValid ? null : errorMessage({formik}))
    }
  }, [formik.isSubmitting])

  useEffect(() => {
    message && scrollToRef(ref)
  }, [message])

  return <div ref={ref}>
    {message && <div className='generic-value negative pb-3'>{message}</div>}
  </div>
})

const errorMessage = ({formik: {errors}}) => {
  if      (errors.recaptcha)        return I18n.t('errors.messages.invalid_recaptcha')
  else if (errors.base)             return errors.base
  else if (errors.stripe_token)     return errors.stripe_token
  else if (errors.client_reference) return I18n.t('donate.errors.client_reference_taken')
  else {
    const fields = Object.keys(errors).map(localizedFieldName).filter(e => e)
    return fields.length ? I18n.t('errors.messages.summary', {fields: toSentence(...fields)}) : null
  }
}

const localizedFieldName = (field) =>
  I18n.t(`donate.attributes.${field}`, {defaultValue: ''})
